import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import ManageTable from "../../components/table/ManageTable";
import Loading from "../../components/customdesign/Loading";
import Typography from "../../components/customdesign/Typography";
import * as ProcessActions from "../../redux/actions/process.actions";
import BpmMetrics from "../metrics/BpmMetrics";

const ListData = () => {
  const dispatch = useDispatch();
  const { defLang, menu } = useSelector((state) => state.Login);
  const { componentConfig, requesting, proccessname } = useSelector((state) => state.Process);

  const [title, setTitle] = React.useState("");

  let { componentName } = useParams();

  React.useEffect(() => {
    dispatch(ProcessActions.getComponentConfig(componentName, defLang));
  }, [componentName, defLang, dispatch]);

  React.useEffect(() => {
    const findMenuTitle = (items = [], parents = []) => {
      for (const item of items) {
        const currentPath = [...parents, item.title];
        if (item.code === componentName) return currentPath.join(" > ");
        const childTitle = findMenuTitle(item.items, currentPath);
        if (childTitle) return childTitle;
      }
      return "";
    };

    setTitle(findMenuTitle(menu));
  }, [menu, componentName]);

  const isCurrentConfig = componentConfig?.componentName === componentName;
  const isLoadingConfig = requesting && proccessname === "getComponentConfig";
  const pageTitle = (isCurrentConfig && componentConfig.title) || (isLoadingConfig ? "" : title || componentName);
  const showTable = isCurrentConfig && componentConfig.columns;
  const showInitialLoading = isLoadingConfig && !showTable;

  // Métricas BPM: el menú configurado (/manage/metrics) se intercepta aquí.
  if (componentName === "metrics") {
    return <BpmMetrics />;
  }

  return (
    <div className={`row xmanage-page xmanage-page--${componentName}`}>
      <div className="xmanage-header">
        <Typography variant="h3" mb={"0"} mt={"0"} style={{ textTransform: "capitalize", display: "flex" }}>
          <span className={"e-" + componentName}> </span>
          <span className="e-component-title">{pageTitle}</span>
        </Typography>
        {showTable && (
          <span className="xmanage-header-count">
            {(componentConfig.rows || []).length} registros
          </span>
        )}
      </div>

      <div className="col-xs-12 no-padding xmanage-content">
        {showInitialLoading && (
          <div className="xmanage-loading">
            <Loading contained transparent label="Cargando datos" />
          </div>
        )}

        {!showInitialLoading && !showTable && (
          <div className="xmanage-empty">
            No se pudo cargar la configuracion de esta vista.
          </div>
        )}

        {showTable && (
          <ManageTable componentName={componentName} />
        )}
      </div>
    </div>
  );
}

export default ListData;
